import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { forwardRef } from "react";
import CircularProgress from "../../../node_modules/@mui/material/CircularProgress/CircularProgress.es.js";
import MUIButton from "../../../node_modules/@mui/material/Button/Button.es.js";
const Button = forwardRef(function Button2({
  loading,
  children,
  disabled,
  endIcon,
  id,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsx(MUIButton, { ref, disableElevation: true, endIcon: loading ? /* @__PURE__ */ jsx(CircularProgress, { color: "inherit", size: "1rem" }) : endIcon, disabled, "aria-disabled": disabled, ...rest, children });
});
export {
  Button
};
//# sourceMappingURL=button.es.js.map
